import { z } from "zod";
import { AgencyDtoSchema, agencyFromDto, AgencySchema } from "./agencies";
import { TourDtoSchema, tourFromDto, TourSchema } from "./tours";
import { apiListSchema } from "./list";

//? DTO
export const CreateTourAgencyDtoSchema = z.object({
  Year: z.number().nullish(),
  Alias: z.string().nullish(),
  AgencyId: z.number().nullish(),
  TourId: z.number().nullish(),

  PriceCommission: z.number().nullish(),
  SeasonSupplementCommission: z.number().nullish(),
  IndividualRoomSupplementCommission: z.number().nullish(),
  SoloTravelerCommission: z.number().nullish(),
  BikesCommissions: z.number().nullish(),
  ExtraNightsCommissions: z.number().nullish(),
  RoomChangeCommissions: z.number().nullish(),
  ServicesCommissions: z.number().nullish(),
});
export type CreateTourAgencyDto = z.infer<typeof CreateTourAgencyDtoSchema>;

export const TourAgencyDtoSchema = CreateTourAgencyDtoSchema.extend({
  Id: z.number(),
  Agency: AgencyDtoSchema.nullish(),
  Tour: TourDtoSchema.nullish(),
});
export type TourAgencyDto = z.infer<typeof TourAgencyDtoSchema>;

export const tourAgenciesDtoListSchema = apiListSchema(TourAgencyDtoSchema);
//? Model

export const CreateTourAgencySchema = z.object({
  year: z.number().nullish(),
  alias: z.string().nullish(),
  agencyId: z.number().nullish(),
  tourId: z.number().nullish(),

  priceCommission: z.number().min(0).nullish(),
  seasonSupplementCommission: z.number().min(0).nullish(),
  individualRoomSupplementCommission: z.number().min(0).nullish(),
  soloTravelerCommission: z.number().min(0).nullish(),
  bikesCommissions: z.number().min(0).nullish(),
  extraNightsCommissions: z.number().min(0).nullish(),
  roomChangeCommissions: z.number().min(0).nullish(),
  servicesCommissions: z.number().min(0).nullish(),
});

export const TourAgencySchema = CreateTourAgencySchema.extend({
  id: z.string().min(1),
  agency: AgencySchema.nullish(),
  tour: TourSchema.nullish(),
});

export type CreateTourAgency = z.infer<typeof CreateTourAgencySchema>;

export type TourAgency = z.infer<typeof TourAgencySchema>;

export type TourAgencyDomain = "agency" | "tour";
//? Mappers

export function tourAgencyFromDto(dto: TourAgencyDto): TourAgency {
  return {
    id: dto.Id.toString(),
    year: dto.Year,
    alias: dto.Alias,
    agencyId: dto.AgencyId,
    tourId: dto.TourId,
    agency: dto.Agency ? agencyFromDto(dto.Agency) : undefined,
    tour: dto.Tour ? tourFromDto(dto.Tour) : undefined,

    bikesCommissions: dto.BikesCommissions,
    extraNightsCommissions: dto.ExtraNightsCommissions,
    individualRoomSupplementCommission: dto.IndividualRoomSupplementCommission,
    priceCommission: dto.PriceCommission,
    roomChangeCommissions: dto.RoomChangeCommissions,
    seasonSupplementCommission: dto.SeasonSupplementCommission,
    servicesCommissions: dto.ServicesCommissions,
    soloTravelerCommission: dto.SoloTravelerCommission,
  };
}

export function tourAgencyToDto(dto: TourAgency): TourAgencyDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createTourAgencyToDto(dto),
  };
}

export function createTourAgencyToDto(
  dto: CreateTourAgency
): CreateTourAgencyDto {
  return {
    Year: dto.year,
    AgencyId: dto.agencyId,
    Alias: dto.alias,
    TourId: dto.tourId,

    BikesCommissions: dto.tourId,
    ExtraNightsCommissions: dto.extraNightsCommissions,
    IndividualRoomSupplementCommission: dto.individualRoomSupplementCommission,
    PriceCommission: dto.priceCommission,
    RoomChangeCommissions: dto.roomChangeCommissions,
    SeasonSupplementCommission: dto.seasonSupplementCommission,
    ServicesCommissions: dto.servicesCommissions,
    SoloTravelerCommission: dto.soloTravelerCommission,
  };
}
